// extracted by mini-css-extract-plugin
export default {"logoImg":"index_logoImg__2cWp+","logoText":"index_logoText__w+qp5","logo":"index_logo__-G6Pa","vendorLogo":"index_vendorLogo__e9Mg5","logoTitle":"index_logoTitle__bJRUX"};